/* eslint-disable */
import React, { useState, useContext, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer";
import CardContent from "@material-ui/core/CardContent";
import GridItem from "components/Grid/GridItem";
import CardHeader from "../../../components/Card/CardHeader.js";
import Card from "../../../components/Card/Card.js";
import Button from "components/CustomButtons/Button";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Tooltip from "@material-ui/core/Tooltip";
import EditSectionModal from "../../../components/EditSectionModal/EditSectionModal.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faChartSimple,
  faExternalLinkAlt,
  faExclamationTriangle,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import CardBody from "components/Card/CardBody.js";
import dayjs from "dayjs";
import InitiativeResultsPage from "views/InitiativesProgram/initiativesResults.js";

import {
  Announcement,
  DoubleArrow,
  Visibility,
  Edit,
  AttachMoney,
  Info,
  Assessment,
  Close,
} from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import AuthContext from "contexts/AuthProvider.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useTranslation } from "react-i18next";

import {
  Checkbox,
  FormControlLabel,
  Dialog,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  ButtonGroup,
} from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import { client } from "../../../services/axiosClient.js";
import { ThreeDots } from "react-loader-spinner";
import DeliverablesOverviewTable from "./AuxComponents/DeliverablesOverviewTable.js";
import RiskSummary from "./AuxComponents/RiskSummary.js";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import OnePage from "views/InitiativesProgram/OnePage_v2.js";
import { Section } from "components/Section/Section";
import ReactSelect from "react-select";
import TextField from "@material-ui/core/TextField";
import initiativeManagementStyle from "assets/jss/material-dashboard-pro-react/views/initiativesManagementStyle.js";
import InitiativeDetails from "views/InitiativesProgram/initiativeDetails.js";
import AIAssistant from "./AuxComponents/AIAssistant.js";

// Importar componentes reutilizáveis
import WhatsHappeningCard from "./AuxComponents/WhatsHappeningCard.js";
import InitiativeDetailsDialog from "./AuxComponents/InitiativeDetailsDialog.js";
import ReadinessCurve from "./AuxComponents/ReadinessCurve.js";

// ----Main component -----------------------------------------
export default function WhatsHappeningV4() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const defaultKpiId = userDetails?.status_kpi_id || 1;
  // console.log(userDetails);

  // ----STATE MANAGEMENT ----
  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [decisions, setDecisions] = useState([]);
  const [initiatives, setInitiatives] = useState([]);

  const [kpis, setKpis] = useState({});

  // Additional states
  const [isLoadingKpis, setIsLoadingKpis] = useState(false);
  const [isLoadingSections, setIsLoadingSections] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Estados de loading adicionais para sincronização (seguindo padrão V3)
  const [isLoadingOverview, setIsLoadingOverview] = useState(false);
  const [isLoadingRotatingKpis, setIsLoadingRotatingKpis] = useState(false);

  // Estados para ReadinessCurve
  const [readinessViewMode, setReadinessViewMode] = useState("mvp");
  const [readinessStats, setReadinessStats] = useState({
    readiness: 0,
    planned: 0,
  });

  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const [isInitiativeDrawerOpen, setIsInitiativeDrawerOpen] = useState(false);
  const [isLoadingInitiativeDetail, setIsLoadingInitiativeDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState("details");

  // Estado para controlar o filtro de críticos
  const [showOnlyCritical, setShowOnlyCritical] = useState(false);

  // Hook for styles + i18n
  const useStylesCustom = makeStyles((theme) =>
    WhatsHappeningStyles(theme, clientColor)
  );

  const classes = useStylesCustom();
  const { t } = useTranslation();

  // -------------- Escolher a section com end_date mais próxima -------------
  useEffect(() => {
    if (sections.length > 0) {
      const closestSection = getClosestSectionToToday(sections);
      if (closestSection) {
        setSelectedSectionId(closestSection.id);
      } else {
        setSelectedSectionId(sections[0].id);
      }
    }
  }, [sections]);

  // -------------- Some style definitions -------------
  const selectedSection = sections.find((s) => s.id === selectedSectionId);

  /* ——— React‑Select skin (mesmo CSS usado na tela de iniciativas) ——— */
  const customStyles = {
    control: (prov, state) => ({
      ...prov,
      minHeight: "80px",
      maxHeight: "80px",
      overflowY: "auto",
      borderColor: state.isFocused ? clientColor : prov.borderColor,
      backgroundColor: "white",
      "&:hover": { borderColor: clientColor },
    }),
    menu: (prov) => ({ ...prov, overflowY: "auto", backgroundColor: "white" }),
    option: (prov, state) => ({
      ...prov,
      color: state.isSelected ? "black" : state.isFocused ? "white" : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor
          : "white",
      "&:active": {
        transform: "scale(0.95)",
        transition: "transform 0.2s ease",
        backgroundColor: clientColor,
      },
    }),
    multiValue: (prov) => ({ ...prov, backgroundColor: "#d3d3d3" }),
    multiValueLabel: (prov) => ({ ...prov, color: "black" }),
    multiValueRemove: (prov) => ({
      ...prov,
      color: "black",
      ":hover": { backgroundColor: "red", color: "white" },
    }),
  };

  /* placeholder renderers (obrigatórios pelo componente, mas não usados aqui) */
  const emptyRenderer = () => null;

  // -------------- useEffect: Buscar KPI no backend -------------
  useEffect(() => {
    async function fetchKpis() {
      if (!defaultKpiId) {
        // console.warn("Default KPI ID is not available. Skipping KPI fetch.");
        setIsLoadingKpis(false);
        return;
      }
      try {
        setIsLoadingKpis(true);
        const response = await client.post("/api/whatshappening-kpi-data/", {
          action: "list",
          kpi_ids: [defaultKpiId],
        });
        if (response.data.success) {
          setKpis(response.data.kpis);
        }
      } catch (err) {
        // console.error("Error fetching main KPI data:", err);
      } finally {
        setIsLoadingKpis(false);
      }
    }
    
    // Só executar se userDetails estiver disponível
    if (userDetails) {
      fetchKpis();
    }
  }, [defaultKpiId, userDetails]);

  // -------------- useEffect: Buscar Overview data do KPI -------------
  useEffect(() => {
    async function fetchKpiOverview() {
      if (!defaultKpiId) {
        // console.warn("Default KPI ID is not available. Skipping KPI overview fetch.");
        setIsLoadingOverview(false);
        return;
      }
      try {
        setIsLoadingOverview(true);
        const response = await client.post("/api/whatshappening-overview-data/", {
          action: "list",
          kpi_id: defaultKpiId,
        });
        if (response.data.success) {
          // Aqui você pode adicionar um estado para os dados de overview se necessário
          // console.log("Overview data loaded successfully");
        } else {
          // console.error("API Error fetching overview data:", response.data.error);
        }
      } catch (err) {
        // console.error("Request failed for overview data:", err);
      } finally {
        setIsLoadingOverview(false);
      }
    }
    
    // Só executar se userDetails estiver disponível
    if (userDetails) {
      fetchKpiOverview();
    }
  }, [defaultKpiId, userDetails]);

  // -------------- useEffect: Buscar Rotating KPIs -------------
  useEffect(() => {
    async function fetchRotatingKpis() {
      if (!defaultKpiId) {
        // console.warn("Default KPI ID is not available. Skipping rotating KPI fetch.");
        setIsLoadingRotatingKpis(false);
        return;
      }
      try {
        setIsLoadingRotatingKpis(true);
        const response = await client.post("/api/whatshappening-rotating-kpi/", {
          action: "list",
          kpi_id: defaultKpiId,
        });
        if (response.data.success) {
          // Aqui você pode adicionar um estado para os rotating KPIs se necessário
          // console.log("Rotating KPIs loaded successfully");
        }
      } catch (error) {
        // console.error("Error fetching rotating KPIs:", error);
      } finally {
        setIsLoadingRotatingKpis(false);
      }
    }
    
    // Só executar se userDetails estiver disponível
    if (userDetails) {
      fetchRotatingKpis();
    }
  }, [defaultKpiId, userDetails]);

  // ENGLISH: Lift the 'isOpen' state for the AI Assistant to the parent component.
  const [isAssistantOpen, setIsAssistantOpen] = useState(false);
  
  // Estado para controlar o modal de riscos
  const [isRiskModalOpen, setIsRiskModalOpen] = useState(false);

  const handleToggleAssistant = () => {
    // console.log("[WhatsHappening] Toggling AI Assistant visibility.");
    setIsAssistantOpen((prev) => !prev);
  };

  // -------------- Carregar Sections + Decisions --------------
  useEffect(() => {
    async function loadInitiatives() {
      try {
        const response = await client.get("/api/decision-initiatives-list/");
        if (response.data.success) {
          setInitiatives(response.data.initiatives);
        }
      } catch (error) {
        // console.error("Error loading initiatives: ", error);
      }
    }
    loadInitiatives();
  }, []);

  useEffect(() => {
    async function loadSectionsAndDecisions() {
      try {
        setIsLoadingSections(true);
        const response = await client.post("/api/control-panel-sections-decisions/", {
          action: "list",
        });
        if (response.data.success) {
          setSections(response.data.sections || []);
          setDecisions(response.data.decisions || []);
        }
      } catch (err) {
        // console.error(err);
      } finally {
        setIsLoadingSections(false);
      }
    }
    loadSectionsAndDecisions();
  }, []);

  // "isLoading" geral só fica false quando as requests terminaram
  const isLoading = isLoadingKpis || isLoadingSections || isLoadingOverview || isLoadingRotatingKpis;

  // Se userDetails não estiver disponível, mostrar loading
  if (!userDetails) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <ThreeDots color="#666" height={80} width={80} ariaLabel="loading" />
      </div>
    );
  }


  // -------------- Escolher a section com end_date mais próxima -------------
  useEffect(() => {
    if (sections.length > 0) {
      const closestSection = getClosestSectionToToday(sections);
      if (closestSection) {
        setSelectedSectionId(closestSection.id);
      } else {
        setSelectedSectionId(sections[0].id);
      }
    }
  }, [sections]);

  // -------------- Carregar iniciativa  -------------
  const handleInitiativeClick = async (initiativeId) => {
    try {
      setIsLoadingInitiativeDetail(true);
      setSelectedInitiative(null);
      const response = await client.post("/api/initiative-detail/", {
        action: "detail",
        initiative_id: initiativeId,
      });
      if (response.data && response.data.success) {
        setSelectedInitiative(response.data.initiative);
        setIsInitiativeDrawerOpen(true);
      } else {
        // console.error("Erro ao buscar detail:", response.data);
      }
    } catch (error) {
      // console.error("Erro no handleInitiativeClick:", error);
    } finally {
      setIsLoadingInitiativeDetail(false);
    }
  };

  // -------------- States e Handlers para KPI da Iniciativa  -------------
  const [initiativeKpisData, setInitiativeKpisData] = useState(null);
  const [isKpiLoading, setIsKpiLoading] = useState(false);
  const [kpiError, setKpiError] = useState(null);

  // ONE PAGE STATES
  const [currentOnePage, setCurrentOnePage] = useState(null);
  const [isLoadingOnePage, setIsLoadingOnePage] = useState(false);
  const [onePageError, setOnePageError] = useState(null);

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  // >>> useEffect para buscar dados de KPIs quando a iniciativa é selecionada:
  useEffect(() => {
    async function fetchKpiData() {
      try {
        if (!selectedInitiative?.id) {
          setInitiativeKpisData(null);
          return;
        }
        setIsKpiLoading(true);
        setKpiError(null);

        const response = await client.post("/api/initiative-results-data/", {
          action: "list",
          initiative_id: selectedInitiative.id,
        });

        if (response.data.success) {
          setInitiativeKpisData(response.data.data);
        } else {
          setKpiError(response.data.error || "Failed to fetch KPI data");
        }
      } catch (err) {
        // console.error("Error fetching KPI data:", err);
        setKpiError("Could not contact the server");
      } finally {
        setIsKpiLoading(false);
      }
    }

    fetchKpiData();
  }, [selectedInitiative]);

  // >>> useEffect para buscar dados de readiness e calcular estatísticas
  useEffect(() => {
    async function fetchReadinessData() {
      if (!selectedSection?.id) {
        setReadinessStats({ readiness: 0, planned: 0 });
        return;
      }

      try {
        const response = await client.post("/api/deliverables-readiness-data/", {
          section_id: selectedSection.id,
          view_mode: readinessViewMode,
        });

        if (response.data.success) {
          const deliverables = response.data.data || [];
          const readinessStatsFromBackend = response.data.readiness_stats || {};
          
          if (deliverables.length > 0) {
            // Usar os stats calculados pelo backend baseado em deliverables concluídos
            let readinessValue = 0;
            let plannedValue = 0;
            
            if (readinessViewMode === 'mvp') {
              readinessValue = readinessStatsFromBackend.mvp_readiness || 0;
            } else if (readinessViewMode === 'launch') {
              readinessValue = readinessStatsFromBackend.launch_readiness || 0;
            }
            
            // Para o planned, continuar calculando baseado nas datas planejadas
            const total = deliverables.length;
            if (total > 0) {
              plannedValue = deliverables.reduce(
                (sum, d) => sum + (d.planned_percentual_conclusion || 0),
                0
              ) / total;
            }

            setReadinessStats({
              readiness: Math.round(readinessValue),
              planned: Math.round(plannedValue),
            });
          } else {
            setReadinessStats({ readiness: 0, planned: 0 });
          }
        }
      } catch (err) {
        // console.error("Error fetching readiness data:", err);
        setReadinessStats({ readiness: 0, planned: 0 });
      }
    }

    fetchReadinessData();
  }, [selectedSection, readinessViewMode]);

  // >>> Refactored function to fetch OnePage data
  const fetchOnePageData = useCallback(async (initiativeId) => {
    if (!initiativeId) {
      setCurrentOnePage(null);
      return;
    }
    try {
      setIsLoadingOnePage(true);
      setOnePageError(null);

      const response = await client.post("/api/whatshappening-onepage/", {
        initiative_id: initiativeId,
      });

      if (response.data.success) {
        setCurrentOnePage(response.data.onepage_data);
      } else {
        // console.error("[DEBUG] WhatsHappening: API returned an error:", response.data.error);
        setOnePageError(response.data.error || "Failed to fetch OnePage data");
        setCurrentOnePage(null);
      }
    } catch (err) {
      // console.error("[DEBUG] WhatsHappening: Network/Request Error:", err);
      setOnePageError("Could not contact the server");
      setCurrentOnePage(null);
    } finally {
      setIsLoadingOnePage(false);
    }
  }, []);

  useEffect(() => {
    if (selectedInitiative?.id) {
      fetchOnePageData(selectedInitiative.id);
    } else {
      setCurrentOnePage(null);
    }
  }, [selectedInitiative, fetchOnePageData]);

  // -------------- Aux function to find closest section -------------
  function getClosestSectionToToday(sectionsArray) {
    const today = dayjs();
    let closestSection = null;
    let minDiff = Infinity;
    for (const section of sectionsArray) {
      if (!section.end_date) continue;
      const diffAbs = Math.abs(dayjs(section.end_date).diff(today, "days"));
      if (diffAbs < minDiff) {
        minDiff = diffAbs;
        closestSection = section;
      }
    }
    return closestSection;
  }

  // -------------- Modal -------------
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setIsInitiativeDrawerOpen(false);
  };

  // -------------- Floating Card -------------
  const renderFloatingCard = () => {
    const selectedSec = sections.find((s) => s.id === selectedSectionId);
    if (!selectedSec) return null;

    return (
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {selectedSec.section_name}
          <span style={{ marginLeft: 2, fontSize: "12px", color: "#666" }}>
            | {t("whatshappening.card_footer.period")}{" "}
            {selectedSec.start_date || "?"} -&gt; {selectedSec.end_date || "?"}
          </span>
        </div>
        <Tooltip title={t("program_meeting.actions.edit_section")}>
          <Edit
            className={classes.iconButtonCustom}
            onClick={handleOpenModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </Tooltip>
        <EditSectionModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          sections={sections}
          setSelectedSectionId={setSelectedSectionId}
          clientColor={clientColor}
        />
      </div>
    );
  };

  // -------------- Styles function -------------
  function WhatsHappeningStyles(theme, cColor) {
    return {
      ...initiativeManagementStyle(theme, clientColor),
      ...customSelectStyle(theme, cColor),
      ...customInputStyle(cColor),
      root: {
        padding: 0,
        margin: 0,
      },
      tabsRoot: {
        backgroundColor: grayColor[8],
      },
      tabRoot: {
        fontSize: "1rem",
        fontWeight: 400,
        color: cColor,
        textTransform: "none",
        "&:hover": {
          color: cColor,
          opacity: 1,
        },
        "&.Mui-selected": {
          color: "black",
          fontWeight: 500,
          borderBottom: `2px solid ${cColor}`,
        },
        "&:focus": {
          color: cColor,
        },
      },
      indicator: {
        backgroundColor: cColor,
        height: "1.5px",
      },
      cardIconTitle: {
        ...cardTitle,
        marginTop: "0px",
        marginBottom: "0px",
        padding: "10px",
        fontSize: "15px",
      },
      addButton: {
        marginBottom: theme.spacing(2),
        height: "22px !important",
        width: "30px !important",
        minWidth: "0 !important",
        position: "relative",
        transition: "all 0.2s",
        margin: "10px 0 0 10px !important",
        padding: "0 !important",
      },
      cardButton: {
        padding: "8px !important",
        margin: "0 !important",
        height: "30px !important",
        width: "30px !important",
        minWidth: "0 !important",
        position: "relative",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
          transform: "scale(1.05)",
        },
      },
      cardButtonIcon: {
        margin: "0 !important",
        width: "18px !important",
        height: "18px !important",
        color: cColor,
      },
      iconButtonCustom: {
        cursor: "pointer",
        "&:hover": {
          color: cColor,
        },
      },
      actionIconsCustom: {
        display: "flex",
        gap: theme.spacing(1),
        justifyContent: "center",
        alignItems: "center",
      },
      center: {
        textAlign: "center",
      },
      tableHeadCell: {
        fontWeight: "bold",
        backgroundColor: "white",
        cursor: "pointer",
      },
      floatingCard: {
        position: "fixed",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1200,
        backgroundColor: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        borderRadius: "0 0 8px 8px",
        padding: "6px 4px 4px 10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: "90%",
        [theme.breakpoints.down("sm")]: {
          position: "static",
          alignItems: "center",
          maxWidth: "100%",
          transform: "none",
          zIndex: 1200,
          borderRadius: 0,
          margin: "-40px 15px 37px 0",
          backgroundColor: "#EEEE",
          borderBottom: "1px solid " + grayColor[4],
          boxShadow: "none",
        },
      },
      floatingCardTitle: {
        fontSize: "14px",
        color: "#333",
        marginRight: "10px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px",
        },
      },
      sortIndicator: {
        marginLeft: theme.spacing(1),
        fontSize: "0.8rem",
      },
      filterContainer: {
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
      },
      filterItem: {
        marginRight: theme.spacing(2),
        minWidth: 200,
      },
      accordionRootCustom: {
        marginBottom: theme.spacing(0.2),
        overflow: "hidden",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
        "&:first-of-type": {
          borderRadius: "10px 10px 10px 10px",
        },
        "&:nth-of-type(2)": {
          borderRadius: "10px 10px 10px 10px",
        },
        "&:last-of-type": {
          borderRadius: "10px 10px 10px 10px",
        },
      },
      textFieldRoot: {
        "& .MuiInput-underline:before": {
          borderBottom: "1px solid #ccc",
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: `2px solid ${cColor}`,
        },
        "& .MuiInput-underline:after": {
          borderBottom: `2px solid ${cColor}`,
        },
      },
      inputText: {
        color: "#666",
        "&:focus": {
          color: "#666",
        },
      },
      labelText: {
        color: "#666",
        "&.Mui-focused": {
          color: "#666",
        },
      },
      sortIcon: {
        fontSize: "14px",
        marginLeft: "6px",
        color: "#ccc",
      },
      activeSortIcon: {
        color: "#aaa",
      },
      stats: {
        color: grayColor[0],
        fontSize: "10px",
        lineHeight: "22px",
        display: "inline-flex",
        "& svg": {
          position: "relative",
          top: "3px",
          width: "16px",
          height: "16px",
          marginRight: "5px",
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
          position: "relative",
          top: "3px",
          fontSize: "16px",
          marginRight: "3px",
        },
      },
      statusCircle: {
        position: "absolute",
        top: "8px",
        right: "-8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        cursor: "pointer",
      },
      modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      sectionList: {
        listStyle: "none",
        padding: 0,
        margin: 0,
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        maxHeight: "80vh",
        overflowY: "auto",
        borderRadius: "10px",
      },
      sectionListItem: {
        padding: theme.spacing(1),
        borderBottom: `1px solid ${cColor}`,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: `${cColor}2A`,
        },
      },
      funnelBar: {
        background: `linear-gradient(135deg, ${cColor}33 0%, ${cColor} 100%)`,
        color: "#fff",
        margin: "0 auto",
        padding: "14px 0",
        borderRadius: "6px",
        transition: "width 0.3s ease-in-out",
        boxShadow: "0 0 6px rgba(0,0,0,0.2)",
        fontWeight: "bold",
      },
      cardBody: {
        flex: 1,
        overflow: "auto",
        padding: "0.9375rem 20px", // Same padding as Material-UI default cardBody
        fontSize: "0.8rem", // Uniform font size
        lineHeight: "1.5", // Uniform line spacing
        color: "#3C3C3C", // Uniform font color
      },
      cardContent: {
        flex: 1,
        overflow: "auto",
        padding: "0.9375rem 20px", // Same padding as cardBody for consistency
        fontSize: "0.8rem", // Uniform font size
        lineHeight: "1.5", // Uniform line spacing
        color: "#3C3C3C", // Uniform font color
      },
      textStyle: {
        fontFamily: "inherit", // Inherit the parent font or set a desired font-family (ex.: '"Roboto", sans-serif')
        fontSize: "0.8rem", // Standard font size
        lineHeight: "1.5", // Standard line height
        color: "#3C3C3C", // Standard text color
      },
      // Estilos para ReadinessCurve no CardHeader
      readinessStat: {
        display: "flex",
        alignItems: "center",
        marginRight: theme.spacing(2),
        fontSize: "0.8rem",
      },
      readinessValue: {
        fontSize: "1.1rem",
        fontWeight: 600,
        marginRight: theme.spacing(0.5),
      },
      readinessLabel: {
        fontSize: "0.7rem",
        color: theme.palette.text.secondary,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      },
      toggleGroup: {
        "& .MuiButton-root": {
          fontSize: "0.7rem",
          padding: "2px 8px",
          border: `1px solid ${cColor}`,
          borderRadius: 0,
          minWidth: "40px",
          height: "24px",
          "&:first-child": {
            borderTopLeftRadius: theme.spacing(0.5),
            borderBottomLeftRadius: theme.spacing(0.5),
          },
          "&:last-child": {
            borderTopRightRadius: theme.spacing(0.5),
            borderBottomRightRadius: theme.spacing(0.5),
          },
          "&.Mui-selected": {
            backgroundColor: cColor,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: cColor,
            },
          },
        },
      },
    };
  }

  return (
    <div>
      {/* Render the floating card */}
      {renderFloatingCard()}
      <GridContainer spacing={0} style={{ marginTop: "-40px", overflow: "hidden" }}>
        {/* ========== PRIMEIRA LINHA ========== */}
        {/* ========== KEY MESSAGES ========== */}
        <WhatsHappeningCard
          title={t("whatshappening.cards_title.program_key_messages")}
          icon={Announcement}
          content={sections.find((s) => s.id === selectedSectionId)?.keyMessage}
          isLoading={isLoading}
          clientColor={clientColor}
          classes={classes}
          t={t}
          selectedSection={selectedSection}
          showStatusCircle={true}
          gridSize={{ xs: 12, sm: 12, md: 4 }}
        />

        {/* ========== NEXT STEPS ========== */}
        <WhatsHappeningCard
          title={t("whatshappening.cards_title.program_next_steps")}
          icon={DoubleArrow}
          content={sections.find((s) => s.id === selectedSectionId)?.next_steps}
          isLoading={isLoading}
          clientColor={clientColor}
          classes={classes}
          t={t}
          selectedSection={selectedSection}
          gridSize={{ xs: 12, sm: 12, md: 4 }}
        />

        {/* ========== RISK SUMMARY ========== */}
        <GridItem xs={12} sm={12} md={4}>
          <Card style={{ height: "90%" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.risk_summary")}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={t("risks.click_for_details") || "Acessar gestão completa de riscos"}
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="sm"
                    variant="outlined"
                    onClick={() => setIsRiskModalOpen(true)}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className={classes.cardButtonIcon}
                      style={{ color: "#FFFFFF" }}
                    />
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            <CardBody
              className={classes.cardBody}
              style={{
                flex: 1,
                overflow: "auto",
                maxHeight: "calc(45vh - 100px)",
              }}
            >
              <PerfectScrollbar>
                <RiskSummary 
                  clientColor={clientColor} 
                  isLoading={isLoading}
                  isModalOpen={isRiskModalOpen}
                  onCloseModal={() => setIsRiskModalOpen(false)}
                />
              </PerfectScrollbar>
            </CardBody>
          </Card>
        </GridItem>

        {/* ========== SEGUNDA LINHA ========== */}

        <GridItem xs={12} sm={12} md={6} style={{ marginTop: "-10px" }}>
          <Card style={{ height: "47vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Assessment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.readiness_curve") || "Curva S de Readiness"}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* Stat de Readiness */}
                <div className={classes.readinessStat}>
                  <Typography
                    className={classes.readinessValue}
                    style={{ color: clientColor }}
                  >
                    {readinessStats.readiness || 0}%
                  </Typography>
                  <Typography className={classes.readinessLabel}>
                    {t("whatshappening.readiness_curve.readiness") || "Readiness"}
                  </Typography>
                </div>
                
                {/* Botões MVP/Launch */}
                <ButtonGroup
                  variant="outlined"
                  size="small"
                  className={classes.toggleGroup}
                >
                  <Button
                    variant={readinessViewMode === "mvp" ? "contained" : "outlined"}
                    color={readinessViewMode === "mvp" ? "primary" : "default"}
                    onClick={() => setReadinessViewMode("mvp")}
                    style={{
                      backgroundColor: readinessViewMode === "mvp" ? clientColor : "transparent",
                      color: readinessViewMode === "mvp" ? "#ffffff" : clientColor,
                      borderColor: clientColor,
                    }}
                  >
                    {t("whatshappening.readiness_curve.mvp") || "MVP"}
                  </Button>
                  <Button
                    variant={readinessViewMode === "launch" ? "contained" : "outlined"}
                    color={readinessViewMode === "launch" ? "primary" : "default"}
                    onClick={() => setReadinessViewMode("launch")}
                    style={{
                      backgroundColor: readinessViewMode === "launch" ? clientColor : "transparent",
                      color: readinessViewMode === "launch" ? "#ffffff" : clientColor,
                      borderColor: clientColor,
                    }}
                  >
                    {t("whatshappening.readiness_curve.launch") || "Lançamento"}
                  </Button>
                </ButtonGroup>
              </div>
            </CardHeader>
            <CardContent 
              className={classes.cardContent}
              style={{ 
                flex: 1, 
                overflow: "auto", 
                height: "calc(47vh - 120px)", 
                position: "relative" 
              }}
            >
              <ReadinessCurve 
                selectedSection={selectedSection}
                clientColor={clientColor}
                isLoading={isLoading}
                viewMode={readinessViewMode}
                onViewModeChange={setReadinessViewMode}
                readinessValue={readinessStats.readiness}
              />
            </CardContent>
          </Card>
        </GridItem>
        {/* ========== DELIVERABLES OVERVIEW TABLE ========== */}
        <GridItem xs={12} sm={12} md={6} style={{ marginTop: "-10px" }}>
          <Card style={{ height: "47vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Visibility />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.deliverables_overview")}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={showOnlyCritical 
                    ? t("deliverables.show_all") || "Mostrar todos"
                    : t("deliverables.show_critical_only") || "Visualizar apenas críticos"
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="sm"
                    variant={showOnlyCritical ? "contained" : "outlined"}
                    onClick={() => {
                      // console.log("[WhatsHappening] Alternando filtro crítico de", showOnlyCritical, "para", !showOnlyCritical);
                      setShowOnlyCritical(!showOnlyCritical);
                    }}
                    className={classes.cardButton}
                  >
                    {showOnlyCritical ? (
                      <Close
                        className={classes.cardButtonIcon}
                        style={{ color: "#FFFFFF" }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className={classes.cardButtonIcon}
                        style={{ color: "#FFFFFF" }}
                      />
                    )}
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            <CardContent 
              className={classes.cardContent}
              style={{ 
                flex: 1, 
                overflow: "hidden", 
                height: "calc(47vh - 120px)", 
                position: "relative", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "flex-start", 
                alignItems: "stretch",
                padding: "0", // Remover padding extra para evitar conflitos
              }}
            >
              <PerfectScrollbar style={{ width: "100%", height: "100%" }} options={{ suppressScrollX: false }}>
                <DeliverablesOverviewTable
                  selectedSection={selectedSection}
                  onInitiativeClick={handleInitiativeClick}
                  initiativeDetailsOpen={isInitiativeDrawerOpen}
                  clientColor={clientColor}
                  showOnlyCritical={showOnlyCritical}
                  isLoading={isLoading}
                />
                { /* console.log("[WhatsHappening] Passando showOnlyCritical para DeliverablesOverviewTable:", showOnlyCritical) */}
              </PerfectScrollbar>
            </CardContent>
          </Card>
        </GridItem>


      </GridContainer>



        {/* ========== TERCEIRA LINHA ========== */}
        {/* ========== CURVA S DE READINESS ========== */}


      {/* ========== INITIATIVE DETAILS DIALOG ========== */}
      <InitiativeDetailsDialog
        isOpen={isInitiativeDrawerOpen}
        onClose={() => setIsInitiativeDrawerOpen(false)}
        selectedInitiative={selectedInitiative}
        isLoadingInitiativeDetail={isLoadingInitiativeDetail}
        clientColor={clientColor}
        classes={classes}
        t={t}
        userDetails={userDetails}
        customStyles={customStyles}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        initiativeKpisData={initiativeKpisData}
        isKpiLoading={isKpiLoading}
        kpiError={kpiError}
        currentOnePage={currentOnePage}
        isLoadingOnePage={isLoadingOnePage}
        onePageError={onePageError}
      />

      <AIAssistant
        key={isAssistantOpen ? "open" : "closed"}
        classes={classes}
        t={t}
        clientColor={clientColor}
        isOpen={isAssistantOpen}
        onToggle={handleToggleAssistant}
      />
    </div>
  );
}
